export class CookieOptions {
    constructor() {
        this.expandKey = true;
        this.isSecureValue = false;
        this.useMemoryFallback = true;
    }
}
